import type { ResponseOf } from "@apis/http/typedRoute";

type UserAssetDetail = NonNullable<ResponseOf<"GET/api/user-assets/detail">>;

export const mapAssetPreviewUrls = (asset: UserAssetDetail): { videoUrl?: string; posterUrl?: string } => {
  const videoUrl = asset.url;
  const posterUrl =
    asset.coverImageUrl ?? asset.vidExtra?.coverImageUrl ?? asset.sourceExtra?.productSummary?.productCoverImageUrl;

  return { videoUrl, posterUrl };
};
